export default __webpack_public_path__ + "alberta-disk.7e57cf7424f187df7b87.svg";